/** @file Builds the PanelEntry of a rig panel: the shared connection and frame around one body view. */
import type { CatalogKey } from '@pose2d/i18n/types';
import type { FunctionComponent } from 'react';
import type { PanelEntry } from '../panelEntry';
import { RigPanelFrame } from './RigPanelFrame';
import type { RigView } from './rigView';
import { useRigPanel } from './useRigPanel';

/** Dock panel `id` titled `title` showing `View` over the working document; rig panels bind no chords. */
export function rigPanel(id: string, title: CatalogKey, View: FunctionComponent<RigView>): PanelEntry {
  function RigPanel() {
    const state = useRigPanel();
    return <RigPanelFrame state={state} testId={`panel-${id}`} render={(view) => <View {...view} />} />;
  }
  return { id, title, bindings: [], component: RigPanel };
}
